import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b05b1bb8")
const _hoisted_1 = { class: "px-6 py-4 flex justify-start font-numeric" }
const _hoisted_2 = { class: "px-6 py-4 flex justify-end font-numeric" }
const _hoisted_3 = {
  key: 0,
  class: "color-green"
}
const _hoisted_4 = {
  key: 1,
  class: "color-red"
}
const _hoisted_5 = { class: "px-6 py-4" }
const _hoisted_6 = { class: "flex items-center justify-end wrap whitespace-nowrap text-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-12" }, " veFlake ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-12" }, " FLAKE ", -1)
_popScopeId()

import { computed } from 'vue';
import { format } from 'date-fns';

import useNumbers from '@/composables/useNumbers';
import useBreakpoints from '@/composables/useBreakpoints';

import { UserLeaveRequests } from '@/services/balancer/subgraph/types';
import useWeb3 from '@/services/web3/useWeb3';

import { bnum } from '@/lib/utils';

import { ColumnDefinition } from '@/components/_global/BalTable/BalTable.vue';
import { BaseFlakeInfos } from '@/services/balancer/subgraph/types';

/**
 * TYPES
 */

type ActivityRow = {
  timeLeft: string;
  flakeAmount: string;
  veFlakeAmount: string;
  tx: string;
  timeExercise: string;
  timestamp: string;
};

type Props = {
  baseFlakeInfos: BaseFlakeInfos[];
  userLeaveRequests: UserLeaveRequests[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    baseFlakeInfos: { type: Array, required: true },
    userLeaveRequests: { type: Array, required: true },
    isLoading: { type: Boolean, required: false, default: false },
    isLoadingMore: { type: Boolean, required: false, default: false },
    loadMore: { type: Function, required: false },
    isPaginated: { type: Boolean, required: false, default: false },
    noResultsLabel: { type: String, required: false }
  } as unknown as undefined,
  emits: ['loadMore'],
  setup(__props: {
  baseFlakeInfos: BaseFlakeInfos[];
  userLeaveRequests: UserLeaveRequests[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
}, { emit }) {

const props = __props




/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const { explorerLinks } = useWeb3();
const { upToLargeBreakpoint } = useBreakpoints();

/**
 * COMPUTED
 */
const columns = computed<ColumnDefinition<ActivityRow>[]>(() => [
  {
    name: 'Due time',
    id: 'TimeToExercise',
    accessor: 'timestamp',
    Cell: 'TimeToExerciseCell',
    width: 150,
    sortable: false,
    align: 'left',
    sortKey: tx => tx.timestamp
  },
  {
    name: 'Status',
    id: 'TimeLeft',
    accessor: 'TimeLeft',
    Cell: 'TimeLeftCell',
    align: 'right',
    className: 'align-center w-40',
    width: 150
  },
  {
    name: 'Amount',
    id: 'AmountToWithdraw',
    accessor: 'AmountToWithdraw',
    Cell: 'AmountToWithdrawCell',
    align: 'right',
    width: 200
  }
]);

const leavingTerm = computed(() =>
  props.baseFlakeInfos ? props.baseFlakeInfos[0].leavingTerm : '0'
);

function isReadyToWithdraw(timestamp) {
  return bnum(Date.now()).lt(
    Number(timestamp * 1000) + Number(leavingTerm.value) * 1000
  );
}

const activityRows = computed<ActivityRow[]>(() =>
  props.isLoading
    ? []
    : props.userLeaveRequests.map(
        ({ id, timestamp, flakeAmount, veFlakeAmount }) => {
          return {
            timeLeft: isReadyToWithdraw(timestamp) ? 'Waiting' : 'Available',
            isReadyToWithdraw: isReadyToWithdraw(timestamp),
            flakeAmount: fNum2(
              bnum(flakeAmount)
                .div(Math.pow(10, 18))
                .toString()
            ),
            veFlakeAmount: fNum2(
              bnum(veFlakeAmount)
                .div(Math.pow(10, 18))
                .toString()
            ),
            tx: id,
            timestamp,
            timeExercise: format(
              (Number(timestamp) + Number(leavingTerm.value)) * 1000,
              'MM-dd HH:mm:ss'
            )
          };
        }
      )
);

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalTable = _resolveComponent("BalTable")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    class: "overflow-x-auto",
    square: _unref(upToLargeBreakpoint),
    noBorder: _unref(upToLargeBreakpoint),
    noPad: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BalTable, {
        columns: _unref(columns),
        data: _unref(activityRows),
        "is-loading": __props.isLoading,
        "is-loading-more": __props.isLoadingMore,
        "is-paginated": __props.isPaginated,
        onLoadMore: _cache[0] || (_cache[0] = ($event: any) => (emit('loadMore'))),
        "skeleton-class": "h-64",
        sticky: "both",
        "initial-state": {
        sortColumn: 'TimeToExercise',
        sortDirection: 'desc'
      }
      }, {
        TimeToExerciseCell: _withCtx((action) => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(action.timeExercise), 1)
        ]),
        TimeLeftCell: _withCtx((action) => [
          _createElementVNode("div", _hoisted_2, [
            (!action.isReadyToWithdraw)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(action.timeLeft), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(action.timeLeft), 1))
          ])
        ]),
        AmountToWithdrawCell: _withCtx((action) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(action.veFlakeAmount) + " ", 1),
              _hoisted_7,
              _createTextVNode(" / " + _toDisplayString(action.flakeAmount) + " ", 1),
              _hoisted_8,
              _createVNode(_component_BalLink, {
                href: _unref(explorerLinks).txLink(action.tx),
                external: "",
                class: "ml-2 flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BalIcon, {
                    name: "arrow-up-right",
                    size: "sm",
                    class: "text-custom-black-350 hover:text-blue-500 transition-colors"
                  })
                ]),
                _: 2
              }, 1032, ["href"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["columns", "data", "is-loading", "is-loading-more", "is-paginated"])
    ]),
    _: 1
  }, 8, ["square", "noBorder"]))
}
}

})